/**
 * Warmtewijzer Widget - Modal Handler
 */

( function() {
	'use strict';

	/**
	 * Initialize modal for warmtewijzer form
	 */
	function initWarmtewijzerModal() {
		const forms = document.querySelectorAll( '.warmtewijzer-form' );

		forms.forEach( ( form ) => {
			// Find the closest widget container and modal
			const widget = form.closest( '.warmtewijzer-widget' );
			if ( ! widget ) {
				return;
			}

			const modal = widget.querySelector( '.warmtewijzer-modal' );
			if ( ! modal ) {
				return;
			}

			// Prevent form submission and show modal
			form.addEventListener( 'submit', ( e ) => {
				e.preventDefault();
				openModal( modal );
			} );

			// Close modal on close button
			const closeBtn = modal.querySelector( '.warmtewijzer-modal__close' );
			if ( closeBtn ) {
				closeBtn.addEventListener( 'click', () => {
					closeModal( modal );
				} );
			}

			// Close modal on confirm button
			const confirmBtn = modal.querySelector( '.warmtewijzer-modal__button' );
			if ( confirmBtn ) {
				confirmBtn.addEventListener( 'click', () => {
					closeModal( modal );
				} );
			}

			// Close modal on overlay click
			const overlay = modal.querySelector( '.warmtewijzer-modal__overlay' );
			if ( overlay ) {
				overlay.addEventListener( 'click', () => {
					closeModal( modal );
				} );
			}

			// Close modal on Escape key
			document.addEventListener( 'keydown', ( e ) => {
				if ( e.key === 'Escape' && modal.getAttribute( 'aria-hidden' ) === 'false' ) {
					closeModal( modal );
				}
			} );
		} );
	}

	/**
	 * Open modal with accessibility features
	 */
	function openModal( modal ) {
		modal.setAttribute( 'aria-hidden', 'false' );
		document.body.style.overflow = 'hidden';

		// Focus the close button
		const closeBtn = modal.querySelector( '.warmtewijzer-modal__close' );
		if ( closeBtn ) {
			closeBtn.focus();
		}
	}

	/**
	 * Close modal and restore focus
	 */
	function closeModal( modal ) {
		modal.setAttribute( 'aria-hidden', 'true' );
		document.body.style.overflow = '';
	}

	// Initialize when DOM is ready
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initWarmtewijzerModal );
	} else {
		initWarmtewijzerModal();
	}

	// Re-initialize on Elementor editor updates
	if ( window.elementorFrontend ) {
		window.elementorFrontend.hooks.addAction(
			'frontend/element_ready/db_warmtewijzer.default',
			initWarmtewijzerModal
		);
	}
} )();

